(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vacorax-comfort-use-cases"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vacorax-comfort-card')) {
    customElements.define('vacorax-comfort-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('.vacorax-use-card__motion');
        this.video = this.querySelector('video');
        this.imageMotion = this.dataset.motionEnabled === 'true';
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.pausedByUser = false;
        this.update = () => {
          const eligible = !this.motionPreference.matches && (this.imageMotion || this.video);
          const playing = !!(eligible && this.visible && !document.hidden && !this.pausedByUser);
          this.dataset.playing = String(playing);
          if (this.button) {
            this.button.hidden = !eligible;
            this.button.textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
            this.button.setAttribute('aria-pressed', String(this.pausedByUser));
          }
          if (this.video) {
            if (playing) {
              this.video.muted = true;
              const playAttempt = this.video.play();
              if (playAttempt) playAttempt.catch(() => {
                this.dataset.playing = 'false';
                if (this.button) this.button.textContent = this.dataset.playLabel;
              });
            } else this.video.pause();
          }
        };
        this.toggle = () => {
          this.pausedByUser = this.dataset.playing === 'true';
          this.update();
        };
        if (this.button) this.button.addEventListener('click', this.toggle);
        this.onVideoReady = () => { this.dataset.videoReady = 'true'; };
        this.onVideoError = () => {
          this.dataset.videoReady = 'false';
          this.video.hidden = true;
          this.video = null;
          this.update();
        };
        if (this.video) {
          this.video.addEventListener('playing', this.onVideoReady);
          this.video.addEventListener('error', this.onVideoError);
        }
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold: .05 });
        this.observer.observe(this);
        this.motionPreference.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.update();
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.motionPreference) this.motionPreference.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        if (this.button) this.button.removeEventListener('click', this.toggle);
        if (this.video) {
          this.video.pause();
          this.video.removeEventListener('playing', this.onVideoReady);
          this.video.removeEventListener('error', this.onVideoError);
        }
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
